import { TitleService } from '@app/core/services/title.service';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Status } from '@app/file-launcher/components/file-launcher/file-launcher.component';
import { ProgressTabsComponent } from '../../../shared/progress-tabs/progress-tabs.component';
import { FileLauncherComponent } from '../file-launcher/file-launcher.component';
import { RouterLink } from '@angular/router';
import { MessageDialogComponent } from '@app/shared/message-dialog/message-dialog.component';
import { EnvService } from '@app/core/services/env.service';
import { SessionService } from '@app/security/session.service';
import { isAutomatedTestingEmail } from '@app/core/utils/automated-testing.util';
import { take } from 'rxjs/operators';

const FEJ_STAGING_WARNING =
  'Proceed only if you intend to upload a TEST file to the STAGING environment.';

@Component({
  selector: 'rn-file-launcher-page',
  templateUrl: './file-launcher-page.component.html',
  styleUrls: ['./file-launcher-page.component.scss'],
  standalone: true,
  imports: [
    ProgressTabsComponent,
    FileLauncherComponent,
    RouterLink,
    MessageDialogComponent,
  ],
})
export class FileLauncherPageComponent implements OnInit, OnDestroy {
  readonly stagingWarningMessage = FEJ_STAGING_WARNING;

  @ViewChild('stagingWarningDialog', { static: true })
  stagingWarningDialog: MessageDialogComponent;

  progressTabs: object[] = [
    { id: 'upload', text: 'Upload' },
    { id: 'run', text: 'Run' },
  ];
  currentTab: 'upload' | 'run' = 'upload';

  constructor(
    private titleService: TitleService,
    private envService: EnvService,
    private sessionService: SessionService,
  ) {}

  ngOnInit(): void {
    this.titleService.activate('File Engine Jobs', 'Upload File');
    this.showStagingWarning();
  }

  ngOnDestroy(): void {
    this.titleService.deactivate();
  }

  updateProgressTabs(newStatus: Status) {
    if (newStatus === 'waitingForFile') {
      this.currentTab = 'upload';
    }

    if (newStatus === 'waitingForAction') {
      this.currentTab = 'run';
    }
  }

  private showStagingWarning(): void {
    if (this.envService.getEnv() !== 'staging') {
      return;
    }

    this.sessionService
      .getCurrentUser()
      .pipe(take(1))
      .subscribe((user) => {
        if (isAutomatedTestingEmail(user?.email_address)) {
          return;
        }

        this.stagingWarningDialog.showMessage();
      });
  }
}
